import { render, staticRenderFns } from "./VatDeclaration.vue?vue&type=template&id=6045b5ea"
import script from "./VatDeclaration.vue?vue&type=script&lang=js"
export * from "./VatDeclaration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports